<template>
  <div class="quiz-row">
    <div class="quiz-row__title">
      <QuizTitle :title="title" />
    </div>
    <div class="quiz-row__list">
      <div class="quiz-row__list-wrapper" :class="{ '-primary': primary }">
        <div
          class="quiz-row__item"
          :class="{ '-primary': primary }"
          v-bind:key="index.toString()"
          v-for="(item, index) in questionsData"
        >
          <QuizItemContainer
            :description="item.description"
            :nextQuestions="item.next_questions"
            :program="item.program"
            :image="item.image"
            :title="item.heading_title"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadQuestionData } from "@/utils";
import QuizItemContainer from "@/containers/QuizItemContainer";
import QuizTitle from "@/components/QuizTitle";

export default {
  name: "QuizRow",
  props: {
    idList: {
      type: [Array, null],
      default: null
    },
    primary: {
      type: Boolean,
      default: false,
      required: false
    },
    title: {
      type: String,
      default: undefined,
      required: false
    }
  },
  components: {
    QuizItemContainer,
    QuizTitle
  },
  computed: {
    questionsData: function() {
      const data = [];
      this.idList.forEach(id => {
        data.push(loadQuestionData(id));
      });
      return data;
    }
  }
};
</script>

<style lang="scss" scoped>
.quiz-row {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__title {
    padding-bottom: spacer("m");

    @include if-tablet {
      padding-bottom: spacer("l");
    }
  }

  &__list {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    padding-bottom: spacer("l");

    @include if-tablet {
      align-items: stretch;
      padding-bottom: 0;
    }
  }

  &__list-wrapper {
    display: flex;
    flex-grow: 1;
    flex-direction: column;

    @include if-tablet {
      align-items: center;
      flex-direction: row;
      justify-content: center;
    }
  }

  &__item {
    margin-bottom: 20px;
    width: 100%;

    @include if-tablet {
      flex-basis: 25%;
      height: 80%;
      margin-bottom: 0;
      max-height: 450px;

      &.-primary {
        flex-basis: 100%;
        height: 100%;
        max-height: 100%;
      }

      &:not(:last-child) {
        margin-right: 50px;
      }
    }
  }
}
</style>
